"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GoogleMapsLoader = void 0;
const scriptLibraryLoader_1 = require("../../../core/library/loader/scriptLibraryLoader");
const constants_1 = require("./constants");
class GoogleMapsLoader extends scriptLibraryLoader_1.ScriptLibraryLoader {
    constructor(googleApiKey) {
        super('GoogleMaps', constants_1.LOAD_CONFIG);
        this.googleApiKey = googleApiKey;
    }
    getUrls() {
        return [constants_1.URL + this.googleApiKey + '&' + constants_1.URL_LIBRARIES_PARAM];
    }
}
exports.GoogleMapsLoader = GoogleMapsLoader;
//# sourceMappingURL=index.js.map